import { useLayoutEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import classNames from 'classnames'

import { HTML_ELEMENT_THEME_PROVIDER_ID } from '../../constants/html'
import { useEventOutside, useMouseDownOutside } from '../../hooks'
import { getQaSelector } from '../../utils/common'

import { QA_NAME_DROPDOWN_CONTEXT } from './Dropdown.constants'
import { getDropdownStyle } from './Dropdown.utils'

import * as styles from './Dropdown.module.css'

/**
 * @deprecated Use components based on `floating-ui`
 */
function Dropdown(props) {
  const {
    children,
    className,
    isDropdownBottomPosition,
    maxHeight,
    maxWidth,
    parentRef,
    qaName,
    rect,
  } = props

  const [portal, setPortal] = useState(null)

  const ref = useEventOutside(props.onClose)

  useMouseDownOutside(ref, props.onClose, parentRef)

  useLayoutEffect(() => {
    const wrapperElement = document.createElement('div')
    const parent = document.getElementById(HTML_ELEMENT_THEME_PROVIDER_ID)

    parent.appendChild(wrapperElement)

    // eslint-disable-next-line react-hooks/set-state-in-effect -- the portal container is created on mount and stored once
    setPortal(wrapperElement)

    return () => {
      wrapperElement.remove()
    }
  }, [])

  if (!portal) {
    return null
  }

  const style = getDropdownStyle(
    rect,
    maxHeight,
    maxWidth,
    isDropdownBottomPosition
  )
  const dropdownClassName = classNames(styles.dropdown, className)

  const qaProps = getQaSelector({
    context: QA_NAME_DROPDOWN_CONTEXT,
    value: qaName,
  })

  return createPortal(
    <div {...qaProps} className={dropdownClassName} ref={ref} style={style}>
      {children}
    </div>,
    portal
  )
}

export default Dropdown
